var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "aside-actions", style: { width: "100%" } },
    [
      _vm.valid_actions.notify_me || _vm.isOutOfStock
        ? _c("outOfStock", {
            attrs: {
              variants: _vm.product.product_variants,
              notify_me_block: _vm.valid_actions.notify_me,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.valid_actions.requires_personalisation
        ? _c("requiresPersonalisation", { attrs: { product: _vm.product } })
        : _vm._e(),
      _vm._v(" "),
      _vm.valid_actions.requires_personalisation_inline
        ? _c("personalisationInline", {
            attrs: { product: _vm.product, variantId: _vm.selectedVariant },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.valid_actions.add_to_cart
        ? _c(
            "addToCart",
            {
              attrs: { product: _vm.product, variantStock: _vm.variantStock },
              on: { "variant-selected": _vm.updateSelectedVariant },
            },
            [
              _vm.valid_actions.engrave
                ? _c("optionalEngraving", {
                    attrs: {
                      product: _vm.product,
                      selectedVariant: _vm.selectedVariant,
                      selectedVariantInStock: _vm.selectedVariantAvailable,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("Messages", { attrs: { product: _vm.product } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }